export enum RouteName {
  LANDING = '/',
  BOOKING_SUCCESS = '/booking-success',
  BOOKING_FAILURE = '/booking-failure',
  BOOKING_ERROR = '/booking-error',
  BOOKING_CHECK_IN = '/booking-check-in',
  LOGIN = '/login',
  SIGNUP = '/signup',
  ADMIN = '/admin',
  DASHBOARD = '/admin/dashboard',
  ALERTS = '/admin/alerts',
  BOOKINGS = '/admin/bookings',
  THEATERS = '/admin/theaters',
  CALENDAR = '/admin/calendar',
  USERS = '/admin/users',
  SETTINGS = '/admin/settings',
  CONTENT = '/admin/content',
  IMPORT_BOOKINGS = '/admin/import',
  WILDCARD = '*',
  LOGS = '/admin/logs',
  BACKUP = '/admin/backup',
  BANNER_SETTINGS = '/admin/banner-settings',
  VOLCANO_BANNER_SETTINGS = '/admin/volcano-banner-settings',
  PROMO_CODES = '/admin/promo-codes',
}